import { buildApi } from '../util/api.util';

export const authapi = buildApi(process.env.REACT_APP_AUTH_API_URL!);
